import { render } from "./OrderSkeleton.vue?vue&type=template&id=31aef8e2&ts=true"
import script from "./OrderSkeleton.vue?vue&type=script&lang=ts"
export * from "./OrderSkeleton.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./OrderSkeleton.vue?vue&type=style&index=0&id=31aef8e2&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__